module.exports = __webpack_public_path__ + "img/selected4-min.5cf98d66.png";